var $034c7393857c8db0$exports = {};
$034c7393857c8db0$exports = {
  "close": "Fechar",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " notifica\xE7\xE3o");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " notifica\xE7\xF5es");
      }
    }), ".");
  }
};
export { $034c7393857c8db0$exports as default };